module.exports = __webpack_public_path__ + "./assets/img/brand4.09661c49.svg";